import styled from "styled-components";

export default styled.button`
  outline: none;
  border: none;
  background: transparent;
  padding: 0 8px;
  position: relative;
  right: -8px;
  display: inline-flex;
  justify-content: center;
  line-height: 0;
  cursor: pointer;
`;
